<template>
  <div>
    <b-button variant="primary"
    @click="() => { showModal = true }">{{text}}</b-button>

    <b-modal id="modal-1"
      size="xl"
      :title="title"
      v-model="showModal"
      @ok="handleOk"
      @cancel="handleCancel">
      <b-form>
        <b-form-group
          v-for="(instructor, index) in visibleInstructors" :key="index"
          :id="`fieldset-${index}`"
          description=""
          :label="`How would you rate ${instructor.user.name}?`"
          label-class="h4"
          valid-feedback="Thank you!"
          :state="instructorRatingValidationState"
        >
          <b-form-rating
            v-model="instructorRatings[index]"
            variant="primary"
            precision="2"></b-form-rating>
          <b-form-invalid-feedback :state="instructorRatingValidationState">
            Please select a rating.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          id="fieldset-1"
          description=""
          label="How well did the training team prepare you for this training?"
          label-class="h4"
          valid-feedback="Thank you!"
          :state="trainingTeamRatingValidationState"
        >
          <b-form-rating
            v-model="trainingTeamRating"
            variant="primary"
            precision="2"></b-form-rating>
          <b-form-invalid-feedback :state="trainingTeamRatingValidationState">
            Please select a rating.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          id="fieldset-1"
          description=""
          label="How well did the training schedule work for you?"
          label-class="h4"
          valid-feedback="Thank you!"
          :state="trainingScheduleRatingValidationState"
        >
          <b-form-rating
            v-model="trainingScheduleRating"
            variant="primary"
            precision="2"></b-form-rating>
          <b-form-invalid-feedback :state="trainingScheduleRatingValidationState">
            Please select a rating.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          id="fieldset-1"
          description=""
          label="How would you rate your overall experience?"
          label-class="h4"
          valid-feedback="Thank you!"
          :state="overallRatingValidationState"
        >
          <b-form-rating
            v-model="overallRating"
            variant="primary"
            precision="2"></b-form-rating>
          <b-form-invalid-feedback :state="overallRatingValidationState">
            Please select a rating.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          id="fieldset-1"
          description=""
          label="Would you recommend your training to a friend or colleague?"
          label-class="h4"
          valid-feedback="Thank you!"
          :state="wouldRecommendValidationState"
        >
          <b-form-radio v-model="wouldRecommend" name="would-recommend" value="1">Yes</b-form-radio>
          <b-form-radio v-model="wouldRecommend" name="would-recommend" value="0">No</b-form-radio>
          <b-form-invalid-feedback :state="wouldRecommendValidationState">
            Please select an option.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          id="fieldset-1"
          description=""
          label="Questions? Comments? Suggestions? We’d love to hear from you!"
          label-class="h4"
          :state="commentValidationState"
        >
          <b-form-textarea
            id="notes-input"
            rows="10"
            v-model="comments"
          ></b-form-textarea>
          <b-form-invalid-feedback :state="commentValidationState">
            We'd love some feedback.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>

export default {
  props: {
    text: {
      typeof: String,
      default: 'Survey'
    },
    title: {
      typeof: String,
      default: 'Take Survey'
    },
    instructors: {
      typeof: Array,
      required: true
    }
  },
  data () {
    return {
      showModal: false,
      instructorRatings: [],
      trainingTeamRating: 0,
      trainingScheduleRating: 0,
      overallRating: 0,
      wouldRecommend: null,
      comments: '',
      submitted: false
    }
  },
  computed: {
    visibleInstructors () {
      return this.instructors.filter(x => x.isVisible)
    },
    instructorRatingValidationState () {
      if (!this.submitted) {
        return null
      }
      return this.instructorRatings.every(x => x > 0)
    },
    overallRatingValidationState () {
      if (!this.submitted) {
        return null
      }
      return this.overallRating > 0
    },
    trainingTeamRatingValidationState () {
      if (!this.submitted) {
        return null
      }
      return this.trainingTeamRating > 0
    },
    trainingScheduleRatingValidationState () {
      if (!this.submitted) {
        return null
      }
      return this.trainingScheduleRating > 0
    },
    wouldRecommendValidationState () {
      if (!this.submitted) {
        return null
      }
      return this.wouldRecommend !== null
    },
    commentValidationState () {
      if (!this.submitted) {
        return null
      }
      return this.comments !== null && this.comments.length > 0
    }
  },
  created () {
    this.instructorRatings = this.instructors.map(x => 0)
  },
  methods: {
    validate () {
      this.submitted = true
      return this.instructorRatingValidationState &&
        this.overallRatingValidationState &&
        this.wouldRecommendValidationState &&
        this.trainingScheduleRatingValidationState &&
        this.trainingTeamRatingValidationState &&
        this.commentValidationState
    },
    handleOk (evt) {
      evt.preventDefault()

      var vm = this
      // Exit when the form isn't valid
      if (!this.validate()) {
        return
      }

      this.$emit('ok',
        {
          instructorRatings: vm.instructorRatings,
          overallRating: vm.overallRating,
          wouldRecommend: vm.wouldRecommend === '1',
          comments: vm.comments,
          trainingScheduleRating: vm.trainingScheduleRating,
          trainingTeamRating: vm.trainingTeamRating
        })

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('modal-1')
      })
    },
    handleCancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>

</style>
